import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import {
  experiencesApi,
  spreedlyCredentialsApiMiddleware,
  userApi,
} from "@capone/common";
import { rootSaga } from "../sagas";
import { rootReducer } from "../reducers";

// REDUX SAGA middleware
export const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      sagaMiddleware,
      experiencesApi.middleware,
      spreedlyCredentialsApiMiddleware,
      userApi.middleware
    ),
  devTools: process.env.NODE_ENV !== "production",
});

sagaMiddleware.run(rootSaga);

export type ExperiencesState = ReturnType<typeof store.getState>;
